import { Tag } from '@loadsmart/loadsmart-ui'

export interface ContentTypeTagProps {
  contentType: string
  size?: 'small' | 'default' | 'large'
}

const CONTENT_TYPE_MAPPING: Record<string, string> = {
  'application/json': 'JSON',
  'application/xml': 'XML',
  'text/plain': 'Plain Text',
  'application/EDI-X12': 'EDI X12',
  'application/octet-stream': 'Binary',
  'application/x-www-form-urlencoded': 'Form URL Encoded',
  'multipart/form-data': 'Multipart Form Data',
}

function getMappedContentType(contentType: string): string {
  // Try to find a mapping key that matches the contentType using regex
  const mappingKey = Object.keys(CONTENT_TYPE_MAPPING).find(key => {
    const regex = new RegExp(`^${key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`, 'i')
    return regex.test(contentType)
  })
  return mappingKey ? CONTENT_TYPE_MAPPING[mappingKey] : contentType
}

export default function ContentTypeTag(props: ContentTypeTagProps) {
  const { contentType, size = 'default' } = props

  return (
    <Tag size={size} variant="outlined">
      <div style={{ whiteSpace: 'nowrap', display: 'inline-flex' }}>
        {getMappedContentType(contentType)}
      </div>
    </Tag>
  )
}
